import React from 'react';
import cx from 'classnames';
import { track } from '@trello/analytics';
import { useUpdateCardCoverMutation } from '@trello/graphql/generated';
import styles from './ColorCover.less';

interface ColorCoverProps {
  cardId: string;
  selectedColor?: string | null;
}

export const cardCoverColors = [
  'blue',
  'green',
  'orange',
  'red',
  'purple',
  'yellow',
];

export const ColorCover: React.FunctionComponent<ColorCoverProps> = ({
  cardId,
  selectedColor,
}) => {
  const [updateCardCover] = useUpdateCardCoverMutation();

  const setCover = async (color: string) => {
    let cover: null | {
      color: string;
    } = {
      color,
    };

    if (color === selectedColor) {
      cover = null;
      track('Card Cover Chooser', 'Toggled Cover Off', 'Color');
    } else {
      track('Card Cover Chooser', 'Chose Cover', 'Color');
    }

    await updateCardCover({
      variables: {
        cardId,
        cover,
      },
    });
  };

  return (
    <div className={styles.colorTiles}>
      {cardCoverColors.map((color) => (
        <button
          key={color}
          onClick={() => setCover(color)}
          className={cx(styles.colorTile, styles[color], {
            [styles.selected]: color === selectedColor,
          })}
        />
      ))}
    </div>
  );
};
